export const selectChallenges = state => state.challenges.challenges || []

export const selectProjectTypes = state => state.challenges.projectTypes

export const selectProductivityChallengeFormData = state => state.challenges.productivityChallengeFormData
